module.exports = __webpack_public_path__ + "static/form-default-values-dont-23a1f58207f3ca30f24d2e0f445efc8f.png";